import React from "react";

function hexToRgbA(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",0.8)";
    }
    console.warn("Bad Hex");
}

export function CarouselStyles(params = {}) {
    const { MobileBreakpoint, palette } = params;

    return {
        "& .carousel": {
            position: "relative",
            overflow: "hidden",

            "& .inner": {
                display: "flex",
                transition: "transform 0.5s ease-in-out",
                width: `calc(100% * var(--carousel-items))`,
                transform: `translateX(calc(-1 * var(--carousel-active-index) * (100% / var(--carousel-items))))`,
            },

            [MobileBreakpoint]: {},
        },

        // TEXT ON IMAGE
        "& .carousel-item": {
            display: "grid",
            gridTemplateColumns: "1fr auto",
            alignItems: "center",
            width: "100%",

            "& .carousel-item-grid": {
                display: "grid",
            },

            "& .carousel-item-text": {
                position: "fixed",
                top: "50%",
                maxWidth: "500px",
                alignSelf: "center",
                padding: "48px",
                margin: "0 48px",
                zIndex: 1,

                fontSize: "30px",
                fontWeight: "700",
                wordBreak: "break-word",

                background: palette.primary.initial,
                background: hexToRgbA(palette.primary.initial),
                color: palette.primary.initialText,

                [MobileBreakpoint]: {
                    alignSelf: "center",
                    width: "200px",
                    padding: "12px",
                    fontSize: "12px",
                },
            },

            "& .carousel-item-image": {
                width: "100%",
                height: "auto",
            },
        },

        // INDICATORS
        "& .carousel-indicators": {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            gap: "6px",
            position: "absolute",
            bottom: "20px",
            left: "0",
            right: "0",
            zIndex: 2,

            "&.hide": {
                display: "none",
            },
        },

        "& .indicator": {
            boxSizing: "border-box",
            width: "8px",
            height: "8px",

            borderRadius: "50%",

            backgroundColor: "#f1f1f1",
            border: "1px solid #999999",

            cursor: "pointer",
            transition: "background-color 0.3s",
        },

        "& .indicator.active": {
            backgroundColor: "#999999",
            border: "1px solid #f1f1f1",
        },

        "& .indicator:hover": {
            transform: "scale(1.2)",
        },

        // BUTTONS
        "& .buttons-container": {
            position: "absolute",
            top: "50%",
            left: "0",
            right: "0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            height: "100%",
            width: "100%",

            transform: "translateY(-50%)",

            "& .prev-button, .next-button": {
                position: "absolute",
                top: 0,
                bottom: 0,
                display: "flex",
                width: "48px",
                height: "100%",

                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(204,204,204,0.5)",
                border: 0,

                opacity: 0,
                transition: "all 300ms ease",
                cursor: "pointer",

                [MobileBreakpoint]: {
                    // ... (мобильные стили кнопок)
                },
            },

            "& .prev-button": {
                left: "0",
            },

            "& .next-button": {
                right: "0",
            },

            "&:hover": {
                "& .prev-button, .next-button": {
                    opacity: 1,
                },
            },

            [MobileBreakpoint]: {
                // display: "none",
                // ... (мобильные стили контейнера кнопок)
            },

            "&.hide": {
                display: "none",
            },
        },
    };
}

export default function Carousel(props) {
    const { items } = props;

    if (!items) {
        return null;
    }

    const _items = items || [];
    if (!Array.isArray(_items)) {
        console.warn("Carousel items is not array!");
        return null;
    }

    const [activeIndex, setActiveIndex] = React.useState(0);
    const [paused, setPaused] = React.useState(false);

    const nextSlide = () => {
        setActiveIndex(prevIndex => (prevIndex + 1) % _items.length);
    };

    const prevSlide = () => {
        setActiveIndex(prevIndex => (prevIndex - 1 + _items.length) % _items.length);
    };

    // Infinite Loop
    React.useEffect(() => {
        const interval = setInterval(() => {
            if (!paused) {
                nextSlide();
            }
        }, 3000);

        return () => {
            clearInterval(interval);
        };
    }, [paused]);

    // Swipe Handlers
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchCurrentY = 0;

    let isTouchMove = false;

    const handleTouchStart = event => {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;

        isTouchMove = false;
    };

    const handleTouchMove = event => {
        touchCurrentX = event.touches[0].clientX;
        touchCurrentY = event.touches[0].clientY;

        const deltaX = Math.abs(touchStartX - touchCurrentX);
        const deltaY = Math.abs(touchStartY - touchCurrentY);

        if (deltaX > deltaY) {
            // Horizontal swipe, prevent vertical scroll
            isTouchMove = true;
            event.cancelable && event.preventDefault();
        }
    };

    const handleTouchEnd = () => {
        if (isTouchMove) {
            const swipeThreshold = 50; // Minimum swipe distance
            const deltaX = touchStartX - touchCurrentX;
            const deltaY = Math.abs(touchStartY - touchCurrentY);

            if (Math.abs(deltaX) > swipeThreshold && deltaY < Math.abs(deltaX)) {
                if (deltaX < 0) {
                    prevSlide();
                } else {
                    nextSlide();
                }
            }
        }

        // Reset touch states
        touchStartX = 0;
        touchStartY = 0;
        touchCurrentX = 0;
        touchCurrentY = 0;

        isTouchMove = false;
    };

    const CNCarousel = ["carousel"];
    const CNSliderButtons = ["buttons-container"];
    const CNSliderIndicators = ["carousel-indicators"];

    const innerStyle = {
        "--carousel-items": _items.length,
        "--carousel-active-index": activeIndex,
    };

    _items.length < 2 && CNSliderButtons.push("hide");
    _items.length < 2 && CNSliderIndicators.push("hide");
    return (
        <div
            className={CNCarousel}
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <div className="inner" style={innerStyle}>
                {_items?.map((item, index) => {
                    if (!item?.image?.retina) {
                        return null;
                    }

                    return (
                        <div className="carousel-item" key={index}>
                            <div className="carousel-item-grid">
                                <img className="carousel-item-image" src={item.image.retina} alt={`Slide ${index}`} />

                                {item.text && (
                                    <div className="carousel-item-text">
                                        <p>{item.text}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className={CNSliderIndicators.join(" ")}>
                {_items?.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator ${index === activeIndex ? "active" : ""}`}
                        ignoreconversion=""
                        onClick={() => setActiveIndex(index)}
                    />
                ))}
            </div>

            <div className={CNSliderButtons.join(" ")}>
                <button className="prev-button" ignoreconversion="" onClick={prevSlide}>
                    <img src="/img/left-arrow.svg" alt="&#8592;" />
                </button>

                <button className="next-button" ignoreconversion="" onClick={nextSlide}>
                    <img src="/img/right-arrow.svg" alt="&#8594;" />
                </button>
            </div>
        </div>
    );
}
